<template>
  <div class="metric-display-section">
    <div class="metrics-wrapper">
      <h4>{{ metricConfig.displayName }}</h4>

      <!-- Basic Metric Display -->
      <div class="basic-metrics">
        <div class="metric-item">
          <p class="title">{{ sessionTypeTitle }} Average</p>
          <p class="value">{{ formatValue(averageValue) }}</p>
        </div>

        <div class="metric-item">
          <p class="title">{{ sessionTypeTitle }} Personal Best</p>
          <p class="value">{{ formatValue(personalBestValue) }}</p>
        </div>

        <div class="metric-item">
          <p class="title">Last Session</p>
          <p
            class="session-date"
            v-if="lastSessionData && lastSessionData.session_date"
          >
            Session date: {{ formatDate(lastSessionData.session_date) }}
          </p>
          <p class="value">{{ formatValue(lastSessionValue) }}</p>
        </div>
      </div>

      <!-- Chart Placeholder -->
      <div class="chart-placeholder" v-if="gpsData && gpsData.length > 0">
        <p>Chart component would be displayed here</p>
        <small>{{ gpsData.length }} sessions available</small>
      </div>
    </div>
  </div>
</template>

<script>
import { UNIT_FORMATTERS } from "./gpsMetricConfigs.js";
import moment from "moment";

export default {
  name: "MetricDisplaySection",
  props: {
    metricConfig: {
      type: Object,
      required: true,
    },
    personalBestAverages: {
      type: Object,
      required: true,
    },
    lastSessionData: {
      type: Object,
      required: true,
    },
    gpsData: {
      type: Array,
      default: () => [],
    },
    sessionType: {
      type: String,
      required: true,
    },
    gpsType: {
      type: String,
      required: true,
    },
    unitValue: {
      type: String,
      default: "Meters",
    },
  },
  computed: {
    sessionTypeTitle() {
      return this.sessionType === "game" ? "Game" : "Training";
    },

    averageValue() {
      const sessionData = this.personalBestAverages[this.sessionType];
      return sessionData?.[this.metricConfig.field] || 0;
    },

    personalBestValue() {
      const pbData = this.personalBestAverages[this.sessionType]?.pb;
      return pbData?.[this.metricConfig.field] || 0;
    },

    lastSessionValue() {
      return this.lastSessionData?.[this.metricConfig.field] || 0;
    },
  },
  methods: {
    formatValue(value) {
      if (!value && value !== 0) return "0";

      const formatter = UNIT_FORMATTERS[this.metricConfig.unit];
      if (formatter) {
        return formatter(value, this.unitValue);
      }

      return Math.round(value).toLocaleString();
    },

    formatDate(date) {
      if (!date) return "No Date";
      return moment(date).format("MMMM Do YYYY");
    },
  },
};
</script>

<style lang="scss" scoped>
.metric-display-section {
  width: 100%;
}

.metrics-wrapper {
  padding: 2rem 0;
  width: 100%;

  h4 {
    text-transform: uppercase;
    color: #333;
    margin-bottom: 2rem;
    font-size: 1.3rem;
  }
}

.basic-metrics {
  display: flex;
  flex-direction: column;
  gap: 2rem;
  margin-bottom: 2rem;

  @media (min-width: 768px) {
    flex-direction: row;
    justify-content: space-around;
  }

  .metric-item {
    background: white;
    border: 1px solid #e9ecef;
    border-radius: 8px;
    padding: 1.5rem;
    text-align: center;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

    .title {
      font-size: 0.9rem;
      text-transform: uppercase;
      color: #6c757d;
      font-weight: 600;
      margin: 0 0 1rem 0;
    }

    .value {
      font-size: 2rem;
      font-weight: bold;
      color: #333;
      margin: 0;
      line-height: 1.2;
    }

    .session-date {
      font-size: 0.8rem;
      color: #6c757d;
      margin: 0 0 0.5rem 0;
    }
  }
}

.chart-placeholder {
  background: #f8f9fa;
  border: 2px dashed #dee2e6;
  border-radius: 8px;
  padding: 2rem;
  text-align: center;
  color: #6c757d;

  p {
    margin: 0 0 0.5rem 0;
    font-size: 1.1rem;
  }

  small {
    color: #868e96;
  }
}
</style>
